module.exports = __webpack_public_path__ + "img/album23_06.7e83d98e.jpg";